// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._14IKJCEjx{max-width:300px}input._54jl6Xfjx,._54jl6Xfjx input{max-width:100%}._1lhySFZlx{flex:1}\n", ""]);
// Exports
exports.locals = {
	"autocomplete": "_14IKJCEjx",
	"input": "_54jl6Xfjx",
	"autocomplete-input-wrapper": "_1lhySFZlx",
	"autocompleteInputWrapper": "_1lhySFZlx"
};
module.exports = exports;
